import React from "react";
import { createRoot } from "react-dom/client";
import Root from "@/Index";
import * as Sentry from "@sentry/browser";
import { API_CONFIG } from "@shared/constants/api";
import { loadBranding } from "@shared/branding";
import '@/utils/videoCallDevTools';

import "@/index.css";
import "rsuite/dist/rsuite.min.css";
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: API_CONFIG.sentry,
    release: "0.1.0",
  });
}
const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
loadBranding().finally(() => root.render(
  // <React.StrictMode>
  <Root />
  // </React.StrictMode>
));
